import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SabisGrid2Module } from 'sabis-grid2';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { SabisComponents2Module, SabisNgxIconsModule, SabisNgxDialogModule, SabisNgxFilePickerModule } from 'sabis-components2';
import { CRUDGridComponent } from './crud/crud-grid/crud-grid.component';
import { SabisEditor2Module } from 'sabis-editor2';

import { CardViewComponent } from './card-view/card-view.component';
import { ListViewComponent } from './list-view/list-view.component';
import { SABISDynamicFormModule } from 'sabis-dynamicform';
import { AppCookiesComponent } from './app-cookies/app-cookies.component';
import { CookiesDetailsComponent } from './app-cookies/cookies-details/cookies-details.component';
import { SABISArrayFilterPipe } from './pipes/sabis-array-filter.pipe';
import { SkipListItemsPipe } from './pipes/skip-list-items.pipe';
import { DocumentViewerComponent } from './documents/document-viewer/document-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';

@NgModule({
  declarations: [
    CRUDGridComponent,
    CardViewComponent,
    ListViewComponent,
    AppCookiesComponent,
    CookiesDetailsComponent,
    SABISArrayFilterPipe,
    SkipListItemsPipe,
    DocumentViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SabisGrid2Module,
    SabisComponents2Module,
    SabisNgxDialogModule,
    SabisNgxIconsModule,
    SabisEditor2Module,
    SabisNgxFilePickerModule,
    SABISDynamicFormModule,

    DragDropModule,

    MatCardModule,
    MatDividerModule,
    MatListModule,
    MatStepperModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatButtonToggleModule,
    NgxDocViewerModule
  ],
  exports: [
    CRUDGridComponent,
    CardViewComponent,
    ListViewComponent,
    AppCookiesComponent,

    SABISArrayFilterPipe,

    SabisGrid2Module,
    SabisComponents2Module,
    SabisNgxDialogModule,
    SabisNgxIconsModule,
    SabisEditor2Module,
    SabisNgxFilePickerModule,
    SABISDynamicFormModule,

    MatCardModule,
    MatDividerModule,
    MatListModule,
    MatStepperModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatTableModule,
  ]
})
export class AppSharedModule { }
